import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContratarGraciasPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-orange-50 to-red-50 flex items-center justify-center px-4 py-32">
      <div className="max-w-2xl w-full text-center">
        {/* Icono de éxito */}
        <div className="flex items-center justify-center mb-8">
          <div className="relative">
            <div className="w-28 h-28 rounded-full bg-gradient-to-br from-emerald-400 to-teal-500 flex items-center justify-center shadow-2xl shadow-emerald-500/30 animate-bounce-slow">
              <i className="ri-checkbox-circle-line text-6xl text-white"></i>
            </div>
            <div className="absolute -top-2 -right-2 w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center shadow-lg">
              <i className="ri-star-fill text-white text-lg"></i>
            </div>
          </div>
        </div>

        {/* Mensaje principal */}
        <div className="bg-white rounded-3xl p-10 shadow-2xl border border-gray-100 mb-8">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ¡Solicitud Recibida!
          </h1>
          <p className="text-xl text-gray-600 mb-6 leading-relaxed">
            Tu solicitud de cotización ha sido ingresada exitosamente. Nuestro equipo de ventas la revisará y se pondrá en contacto contigo a la brevedad.
          </p>

          {/* Número de referencia visual */}
          <div className="bg-gradient-to-r from-orange-50 to-red-50 border-2 border-orange-200 rounded-2xl p-6 mb-8">
            <p className="text-sm font-semibold text-orange-600 uppercase tracking-wider mb-2">
              Estado de tu solicitud
            </p>
            <div className="flex items-center justify-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-emerald-100 text-emerald-600">
                <i className="ri-check-line text-xl"></i>
              </div>
              <span className="text-lg font-bold text-gray-800">
                Solicitud ingresada y en proceso de revisión
              </span>
            </div>
          </div>

          {/* Pasos siguientes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="flex flex-col items-center p-4 bg-gray-50 rounded-xl">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-orange-100 text-orange-600 mb-3">
                <i className="ri-mail-check-line text-2xl"></i>
              </div>
              <p className="text-sm font-semibold text-gray-800 text-center">Confirmación por email</p>
              <p className="text-xs text-gray-500 text-center mt-1">Recibirás un correo de confirmación</p>
            </div>
            <div className="flex flex-col items-center p-4 bg-gray-50 rounded-xl">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-teal-100 text-teal-600 mb-3">
                <i className="ri-user-voice-line text-2xl"></i>
              </div>
              <p className="text-sm font-semibold text-gray-800 text-center">Te contactamos</p>
              <p className="text-xs text-gray-500 text-center mt-1">En menos de 24 horas hábiles</p>
            </div>
            <div className="flex flex-col items-center p-4 bg-gray-50 rounded-xl">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 text-emerald-600 mb-3">
                <i className="ri-rocket-line text-2xl"></i>
              </div>
              <p className="text-sm font-semibold text-gray-800 text-center">Activación del servicio</p>
              <p className="text-xs text-gray-500 text-center mt-1">Rápida y sin complicaciones</p>
            </div>
          </div>

          {/* Botones de acción */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => navigate('/')}
              className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-xl font-bold text-lg hover:shadow-xl hover:shadow-orange-500/30 transition-all hover:scale-105 whitespace-nowrap"
            >
              <span className="flex items-center justify-center gap-2">
                <i className="ri-home-line text-xl"></i>
                Volver al Inicio
              </span>
            </button>
            <a
              href="https://wa.me/56942470111?text=Hola%2C%20acabo%20de%20enviar%20una%20solicitud%20de%20cotizaci%C3%B3n%20y%20quisiera%20m%C3%A1s%20informaci%C3%B3n."
              target="_blank"
              rel="nofollow noreferrer"
              className="w-full sm:w-auto px-8 py-4 bg-green-500 hover:bg-green-600 text-white rounded-xl font-bold text-lg transition-all hover:scale-105 whitespace-nowrap"
            >
              <span className="flex items-center justify-center gap-2">
                <i className="ri-whatsapp-line text-xl"></i>
                Contactar por WhatsApp
              </span>
            </a>
          </div>
        </div>

        {/* Info adicional */}
        <p className="text-sm text-gray-500">
          ¿Tienes alguna duda? Escríbenos a{' '}
          <a href="mailto:ventas@ehostingchile.com" className="text-orange-600 font-semibold hover:underline">
            ventas@ehostingchile.com
          </a>{' '}
          o llámanos al{' '}
          <a href="tel:+56225819100" className="text-orange-600 font-semibold hover:underline">
            +56 2 2581 9100
          </a>
        </p>
      </div>
    </div>
  );
}
